<template>
  <v-dialog
    v-model="show"
    width="1100"
  >
    <v-card class="dialogBackground">
      <v-row
        no-gutters
        class="dialogTitleBackground white--text px-2 py-1 mb-2"
        align="center"
      >
        <span class="mx-2">Заявка №</span>
        <span class="">{{ requestHeader.number }}</span>
        <span class="mx-2"> от </span>
        <span class="">{{ requestHeader.date | dateFormat }}</span>
        <span
          v-if="requestLoaded"
          class="mx-2 grey--text"
        >[ {{ request.requestType.name }} ]</span>
        <v-spacer />
        <span class="grey--text mr-4">ID: {{ requestHeader.id }}</span>
        <v-btn
          small
          icon
          dark
          @click="closeClick"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>

      <!-- Кнопки -->
      <v-row
        dense
        no-gutters
        class="mb-1"
      >
        <v-col
          v-if="!readOnly && requestLoaded"
          class="pl-1"
        >
          <ActionButton
            v-if="request.requestTypeID === 1"
            icon="mdi-upload"
            color="orange"
            title="На разгрузку"
            :disabled="!canUnload"
            :loading="unloadButtonBusy"
            @click="unload()"
          />
          <ActionButton
            v-else
            icon="mdi-download"
            color="orange"
            title="На сборку"
            :disabled="!canLoad"
            :loading="loadButtonBusy"
            @click="load()"
          />
          <ActionButton
            v-if="request.cargoType.useTrackers"
            icon="mdi-satellite-uplink"
            color="blue-grey"
            title="Трекеры"
            :disabled="!canTrackers"
            @click="trackers()"
          />
          <ActionButton
            icon="mdi-printer"
            color="blue"
            title="Печать"
            :disabled="!canPrint"
            :loading="printButtonBusy"
            @click="print()"
          />
          <ActionButton
            v-if="request.requestStatusID === -10"
            icon="mdi-refresh"
            color="primary"
            title="Обработать"
            :disabled="!canReprocess"
            :loading="reprocessButtonBusy"
            @click="reprocess()"
          />
        </v-col>
      </v-row>

      <v-row
        no-gutters
        class="pa-1"
      >
        <!-- Заявка -->
        <v-col :cols="requestLoaded && request.mailGuids.length ? 8 : 12">
          <v-card
            outlined
            tile
            class="d-flex flex-column"
            style="height: 400px"
          >
            <!-- Шапка -->
            <v-card
              tile
              flat
              class="pa-1 pt-2 pb-0"
            >
              <v-row dense>
                <!-- Номер накладной -->
                <v-col
                  v-if="request.requestTypeID === 1"
                  class="pb-0"
                  cols="3"
                >
                  <v-skeleton-loader
                    v-if="!requestLoaded"
                    type="text"
                  />
                  <v-text-field
                    v-else
                    v-model="request.invoiceNum"
                    dense
                    label="Номер накладной"
                    aria-autocomplete="off"
                    class="font14"
                    :disabled="readOnly"
                    :error-messages="objectErrors(this.$v.request.invoiceNum)"
                    :counter="this.$v.request.invoiceNum.$params.maxLength.max"
                    @input="$v.request.invoiceNum.$touch()"
                    @blur="$v.request.invoiceNum.$touch()"
                  />
                </v-col>
                <!-- Дата приходной накладной -->
                <v-col
                  v-if="request.requestTypeID === 1"
                  class="pb-0"
                  cols="3"
                >
                  <v-skeleton-loader
                    v-if="!requestLoaded"
                    type="text"
                  />
                  <DateInput
                    v-else
                    v-model="request.invoiceDate"
                    dense
                    label="Дата накладной"
                    :disabled="readOnly"
                  />
                </v-col>
                <v-spacer />
                <!-- Поддонов -->
                <v-col
                  class="pb-0"
                  cols="3"
                >
                  <v-skeleton-loader
                    v-if="!requestLoaded"
                    type="text"
                  />
                  <v-text-field
                    v-else
                    v-model="qtyPallet"
                    dense
                    readonly
                    label="Поддонов, шт"
                  />
                </v-col>
                <!-- Тоннаж -->
                <v-col
                  class="pb-0"
                  cols="3"
                >
                  <v-skeleton-loader
                    v-if="!requestLoaded"
                    type="text"
                  />
                  <v-text-field
                    v-else
                    v-model="massa"
                    dense
                    readonly
                    label="Масса, тонн"
                  />
                </v-col>
                <!-- Контрагент -->
                <v-col
                  class="pb-0"
                  cols="12"
                >
                  <v-text-field
                    v-model="request.counterpart"
                    dense
                    readonly
                    label="Контрагент"
                    class="counterpart"
                  />
                </v-col>
              </v-row>
            </v-card>
            <!-- Тело -->
            <v-card
              tile
              flat
              :class="($vuetify.theme.dark ? 'darkScrollbar ' : '') + 'pa-1 pt-0 flex-grow-1 overflow-y-auto'"
            >
              <v-skeleton-loader
                v-if="!requestLoaded"
                type="table-row@3"
              />
              <table
                v-else
                class="detailsTable"
              >
                <thead>
                  <tr>
                    <th class="tableHeader tableHeaderText--text">
                      Артикул
                    </th>
                    <th class="tableHeader tableHeaderText--text">
                      Наименование
                    </th>
                    <th class="tableHeader tableHeaderText--text">
                      Штук
                    </th>
                    <th class="tableHeader tableHeaderText--text">
                      Упаковок
                    </th>
                    <th class="tableHeader tableHeaderText--text">
                      Поддонов
                    </th>
                    <th
                      v-if="request.cargoType.usePartNumber"
                      class="tableHeader tableHeaderText--text"
                    >
                      Партия
                    </th>
                    <th
                      v-else
                      class="tableHeader tableHeaderText--text"
                    >
                      Дата произв.
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="detail in request.requestDetails"
                    :key="detail.id"
                  >
                    <td class="article">
                      {{ detail.good.article }}
                    </td>
                    <td class="ellipsis">
                      <span>{{ detail.good.name }}</span>
                    </td>
                    <td class="qty">
                      {{ detail.qty }}
                    </td>
                    <td class="qty">
                      {{ Math.ceil(detail.qty / detail.good.qiPackage) }}
                    </td>
                    <td class="qty">
                      {{ Math.ceil(detail.qty / detail.good.qiPallet) }}
                    </td>
                    <!-- партия / дата производства -->
                    <td
                      v-if="request.cargoType.usePartNumber"
                      class="partNumber"
                    >
                      {{ detail.partNumber }}
                    </td>
                    <td
                      v-else
                      class="productionDate"
                    >
                      {{ detail.productionDate | dateFormat }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-card>
          </v-card>
        </v-col>
        <!-- Письмо -->
        <v-col
          v-if="requestLoaded && request.mailGuids.length"
          cols="4"
          class="pl-1"
        >
          <v-card
            outlined
            tile
            class="d-flex flex-column"
            style="height: 400px"
          >
            <!-- Тело -->
            <v-card
              tile
              flat
              :class="($vuetify.theme.dark ? 'darkScrollbar ' : '') + 'pa-1 flex-grow-1 overflow-y-auto'"
            >
              <v-skeleton-loader
                v-if="!mailLoaded"
                type="paragraph@2"
                class="pt-1"
              />
              <!-- eslint-disable vue/no-v-html -->
              <span
                v-else
                class="mailMessageBody"
                v-html="mailMessage.body"
              ></span>
              <!-- eslint-enable vue/no-v-html -->
            </v-card>
            <!-- Вложения -->
            <v-card
              v-if="mailLoaded && mailMessage.attachs.length"
              tile
              flat
              class="pl-1 pt-1"
            >
              <v-divider class="ma-1" />
              <Attachment
                v-for="attach in mailMessage.attachs"
                :id="attach.id"
                :key="attach.id"
                :name="attach.name"
                :content-type="attach.contentType"
              />
            </v-card>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import DateInput from "@/components/DateInput"
import ActionButton from "@/components/ActionButton"
import Attachment from "@/components/Attachment"
import { required, maxLength } from "vuelidate/lib/validators"

export default {
  components: {
    DateInput,
    ActionButton,
    Attachment
  },

  props: {
    value: { type: Object, default: null } // показать диалог если есть открываемый элемент
  },

  data: () => ({
    requestHeader: Object,
    requestLoaded: false,
    mailLoaded: false,
    loadButtonBusy: false,
    unloadButtonBusy: false,
    printButtonBusy: false,
    reprocessButtonBusy: false,
    mailMessage: {
      body: "",
      attachs: []
    },
    request: Object
  }),

  computed: {
    show: {
      get() {
        // показываем если id != 0
        return this.requestHeader.id
      },
      set(val) {
        this.$v.$reset()
        if (!val) {
          // сбрасываем объект, который передавали в диалог
          this.$emit("input", null)
        }
      }
    },

    massa() {
      return (this.request.requestDetails.reduce((acc, c) => acc + c.qty * c.good.weight, 0) / 1000).toFixed(2)
    },

    qtyPallet() {
      return this.request.requestDetails.reduce((acc, c) => acc + Math.ceil(c.qty / c.good.qiPallet), 0)
    },

    canUnload() {
      return (
        this.requestLoaded &&
        this.request.invoiceNum &&
        this.request.invoiceDate &&
        this.request.requestStatusID === 10 &&
        // машина есть на складе
        this.request.carQueueID &&
        (this.$store.state.auth.user.role === "Управляющий" ||
          this.$store.state.auth.user.role === "Кладовщик" ||
          this.$store.state.auth.user.role === "Администратор")
      )
    },

    canLoad() {
      return (
        this.requestLoaded &&
        (this.request.requestStatusID === 10 || this.request.requestStatusID === -10) &&
        (this.$store.state.auth.user.role === "Управляющий" ||
          this.$store.state.auth.user.role === "Кладовщик" ||
          this.$store.state.auth.user.role === "Администратор")
      )
    },

    canPrint() {
      return (
        this.requestLoaded &&
        (this.request.trackersTakedOff || !this.request.cargoType.useTrackers) &&
        (this.request.requestTypeID === 1
          ? this.request.requestStatusID >= 50 // Выгружена или обработана
          : this.request.requestStatusID === 110) // Загружена
      )
    },

    canTrackers() {
      return (
        this.requestLoaded &&
        this.request.requestStatusID !== -10 && // если ошибка обработки, то нельзя трекеры
        // машина есть на складе
        this.request.carQueueID
      )
    },

    canReprocess() {
      return this.requestLoaded && this.request.requestStatusID === -10 // если ошибка обработки
    },

    readOnly() {
      return (
        this.$store.state.auth.user.role !== "Управляющий" &&
        this.$store.state.auth.user.role !== "Администратор" &&
        this.$store.state.auth.user.role !== "Кладовщик"
      )
    }
  },

  watch: {
    value(val) {
      if (val) {
        this.requestHeader = val
        this.onInit()
      } else {
        this.requestHeader = {}
        this.onClose()
      }
    }
  },

  validations() {
    return {
      request: {
        invoiceNum: { required, maxLength: maxLength(20) }
      }
    }
  },

  methods: {
    objectErrors(obj) {
      if (!obj.$dirty) return []
      const errors = []

      obj.$params.maxLength && !obj.maxLength && errors.push(`Максимум ${obj.$params.maxLength.max} символов`)

      obj.$params.required && !obj.required && errors.push("Введите значение")
      return errors
    },

    async onInit() {
      try {
        const response = await this.axios.get(`/requests/get/${this.requestHeader.id}`)
        this.request = response.data
        this.request.requestDetails = this.sortDetails(this.request.requestDetails)
        this.requestLoaded = true
        // загрузка письма (если оно есть
        if (this.request.mailGuids.length) {
          await this.loadMail(this.request.mailGuids)
        }
      } catch (err) {
        this.$router.push(`/error?message=Ошибка при загрузке заявки&&error=${err}`)
      }
    },

    onClose() {
      this.requestLoaded = false
      this.mailLoaded = false
    },

    async loadMail(mailGuids) {
      const stopWord = "С уважением"
      const ignoreLines = [
        "From: ",
        "Sent: ",
        "To: ",
        "Subject: ",
        "Cc: ",
        "доброе утро",
        "добрый день",
        "добрый вечер"
      ]
      // собрать mailMessage
      const attachs = []
      let body = ""
      // сортировка в обратном порядке
      mailGuids.sort((a, b) => b.id - a.id)
      // цикл по письмам
      for (let i = 0; i < mailGuids.length; i++) {
        const response = await this.axios.get(`/mailService/mailMessage/${mailGuids[i].guid}`, { baseURL: "/" })
        const { textBody, attachments, date } = response.data
        if (textBody?.length) {
          // порезать лишние строки
          let newBody = ""
          let lastLine = ""
          const lines = textBody.split("\n")
          for (let l = 0; l < lines.length; l++) {
            const line = lines[l].trim()
            if (line.startsWith(stopWord)) break
            if (lastLine != line && !ignoreLines.find((il) => line.startsWith(il))) {
              lastLine = line
              newBody += (newBody.length > 0 ? "<br>" : "") + lastLine
            }
          }
          // объеденить тела писем
          if (newBody.length) {
            if (body.length) {
              body += (body.endsWith("<br>") ? "" : "<br>") + `<hr><br>Дополнение от ${this.$dateTimeFormat(date)}<br>`
            }
            body += newBody
          }
        }
        // объединить вложения
        attachments.forEach((a) => {
          !attachs.find((x) => x.name.toLowerCase() === a.name.toLowerCase()) &&
            attachs.push({
              id: a.guid,
              name: a.name,
              contentType: a.contentType
            })
        })
      }
      this.mailMessage = {
        body,
        attachs
      }
      this.mailLoaded = true
    },

    async unload() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }
      try {
        this.unloadButtonBusy = true

        if (
          !(await this.$messageBox(
            `Послать на разгрузку заявку № <span class="accent--text">${this.request.number}</span>,<br>
          водитель <span class="accent--text">${this.request.driver}</span>?`
          ))
        )
          return

        await this.axios.post("/requests/unload", {
          requestId: this.request.id,
          invoiceDate: this.request.invoiceDate,
          invoiceNum: this.request.invoiceNum
        })
        this.closeClick()
        this.$notify("success", "Заявка отправлена на разгрузку")
      } catch (err) {
        this.$notify(
          "error",
          err.response?.data?.message ? err.response.data.message : "Ошибка при отправке на разгрузку"
        )
      } finally {
        this.unloadButtonBusy = false
      }
    },

    async load() {
      if (
        !(await this.$messageBox(`Послать на сборку заявку № <span class="accent--text">${this.request.number}</span>,
        <br>водитель <span class="accent--text">${this.request.driver}</span>?`))
      ) {
        return
      }
      try {
        this.loadButtonBusy = true
        const err = await this.axios.post(`/requests/load/${this.request.id}`)
        if (!err.data?.goods?.length) {
          this.closeClick()
          this.$notify("success", "Заявка отправлена на сборку")
          return
        }
        let body = `
          <br><span class='pl-4'>Некоторых позиций нет на остатках</span><br><br>
          <table width="100%" cellspacing="4" style="font-size: 0.75rem" class="styled-table mainBackground">
            <thead class="tableHeader"><tr>
              <th>Артикул</th><th>Наименование товара</th><th>В заявке, шт</th>
              <th>${err.data.usePartNumber ? "Партия" : "Дата произв."}</th>
              <th>На складе, шт</th></tr>
            </thead><tbody>`
        body +=
          err.data.goods.slice(0, err.data.goods.length > 8 ? 8 : err.data.goods.length).reduce(
            (acc, r) =>
              (acc +=
                `
                <tr>
                <td align="center">${r.article}</td>
                <td>${r.name}</td>
                <td align="center">${r.qty.toFixed(0)}</td>
                <td align="center">` +
                (err.data.usePartNumber
                  ? `${r.partNumber ?? ""}`
                  : `${r.productionDate ? this.$dateFormat(r.productionDate) : ""}`) +
                `</td>
                <td align="center">${r.restQty.toFixed(0)}</td>
                </tr>`),
            ""
          ) + "</tbody></table>"
        await this.$messageBox(body, { class: "pa-1", cancel: false })
      } catch (err) {
        this.$notify("error", err.response?.data?.message ? err.response.data.message : "Ошибка при отправке на сборку")
      } finally {
        this.loadButtonBusy = false
      }
    },

    async print() {
      try {
        this.printButtonBusy = true
        const response = await this.axios.get(`/requests/print/${this.request.id}`)
        window.open(response.data, "_blank")
      } catch (err) {
        this.$notify("error", err.response?.data?.message ? err.response.data.message : "Ошибка при печати документов")
      } finally {
        this.printButtonBusy = false
      }
    },

    trackers() {},

    async reprocess() {
      if (
        !(await this.$messageBox(
          `Обработать повторно заявку № <span class="accent--text">${this.request.number}</span>,
        <br>водитель <span class="accent--text">${this.request.driver}</span>?`
        ))
      ) {
        return
      }
      this.reprocessButtonBusy = true
      await this.axios.post(`/requests/reprocess/${this.request.id}`).catch(() => {
        this.$router.push("/error?message=Ошибка при повторной обработке заявки")
      })
      this.reprocessButtonBusy = false
    },

    closeClick() {
      this.show = false
    },

    sortDetails(src) {
      // временный массив содержит объекты с позицией и значением для сортировки
      var mapped = src.map(function (el, i) {
        return {
          index: i,
          value: {
            article: el.good.article,
            partNumber: el.partNumber,
            productionDate: new Date(el.productionDate)
          }
        }
      })

      // сортируем массив, содержащий уменьшенные значения
      mapped.sort(function (a, b) {
        if (a.value.article > b.value.article) return 1
        if (a.value.article < b.value.article) return -1

        if (a.value.partNumber > b.value.partNumber) return 1
        if (a.value.partNumber < b.value.partNumber) return -1

        if (a.value.productionDate > b.value.productionDate) return 1
        if (a.value.productionDate < b.value.productionDate) return -1

        return 0
      })

      return mapped.map(function (el) {
        return src[el.index]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mailMessageBody {
  font-size: 0.875rem;
  line-height: 1;
}

.counterpart {
  font-size: 0.875rem;
}

.detailsTable {
  font-size: 0.75rem;
  width: 100%;

  td {
    margin: 0 1px;
    padding: 0 5px;

    &.article {
      text-align: center;
      width: 100px;
    }

    &.qty {
      text-align: right;
      width: 75px;
    }

    &.partNumber {
      text-align: center;
      width: 100px;
    }

    &.productionDate {
      text-align: center;
      width: 100px;
    }

    &.ellipsis {
      position: relative;
    }

    &.ellipsis:before {
      content: ".";
      visibility: hidden;
    }

    &.ellipsis span {
      position: absolute;
      left: 0;
      right: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
